import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import $ from "jquery";

import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

const PAGE_BODY_CLASS = "bet-id-wise-details-page";

const BetIdWiseDetails = () => {
  const { cat_mid, market_type } = useParams();

  const [event, setEvent] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("allusers");
  const [gridKey, setGridKey] = useState(Date.now());

  const tableRef = useRef(null);

  useEffect(() => {
    document.documentElement.classList.add(PAGE_BODY_CLASS);
    document.body.classList.add(PAGE_BODY_CLASS);
    return () => {
      document.documentElement.classList.remove(PAGE_BODY_CLASS);
      document.body.classList.remove(PAGE_BODY_CLASS);
    };
  }, []);

  const fetchData = async (reqtype) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(`/markets/bets-idwise/${cat_mid}`, {
        market_type,
        reqtype
      });
      setEvent(res.data.event);
      setRows(res.data.returnResult || []);
      setGridKey(Date.now());
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(activeTab);
  }, [cat_mid, activeTab]);

  const formatValue = (obj) => {
    if (!obj) return "0";
    return `<span style="color:${obj.color}">${Number(
      obj.value
    ).toLocaleString()}</span>`;
  };

  const getTitle = (teamName, market_type, teamNumber) => {
    if (market_type == 5) {
      if (teamNumber == 1) {
        return "Yes";
      } else {
        return "No";
      }
    } else {
      return teamName;
    }
  };

  const cols = useMemo(() => {
    if (!event) return [];

    const c = [
      {
        title: "User Name",
        data: "username",
        className: "all",
        render: (d) => `<span class="site_family">${d}</span>`,
        orderable: true,
        responsivePriority: 1
      },

      {
        title: getTitle(event.cat_rnr1, market_type, 1),
        data: "rnr1",
        className: "all",
        orderable: true,
        responsivePriority: 1,
        render: (data, type, row) => {
          if (type === "sort" || type === "type" || type === "filter") {
            return row.rnr1_sort ?? 0;
          }
          return `<span class="site_family">${data}</span>`;
        }
      },

      {
        title: getTitle(event.cat_rnr2, market_type, 2),
        data: "rnr2",
        className: "all",
        orderable: true,
        responsivePriority: 1,
        render: (data, type, row) => {
          if (type === "sort" || type === "type" || type === "filter") {
            return row.rnr2_sort ?? 0;
          }
          return `<span class="site_family">${data}</span>`;
        }
      }
    ];

    if (event.cat_rnr3 && event.cat_rnr3 !== "NA" && market_type !== "5") {
      debugger;
      c.push({
        title: event.cat_rnr3,
        data: "rnr3",
        className: "all",
        orderable: true,
        responsivePriority: 1,
        render: (data, type, row) => {
          if (type === "sort" || type === "type" || type === "filter") {
            return row.rnr3_sort ?? 0;
          }
          return `<span class="site_family">${data}</span>`;
        }
      });
    }

    return c;
  }, [event]);

  const alignFooterInfoBetweenFirstTwoColumns = (api) => {
    const $footer = $(".bet-id-wise-details .bet-id-wise-details-dt-footer");
    const $infoWrap = $footer.find(".bet-id-wise-details-dt-info-wrap");
    if (!$footer.length || !$infoWrap.length) return;

    if (window.matchMedia("(max-width:640px)").matches) {
      $infoWrap.css({ left: "", transform: "", top: "" });
      return;
    }

    const $ths = $(api.table().node()).find("thead th");
    if ($ths.length < 2) return;

    const footerLeft = $footer.offset().left;
    const firstColLeft = $ths.eq(0).offset().left;
    const secondColRight =
      $ths.eq(1).offset().left + $ths.eq(1).outerWidth();
    const midX = (firstColLeft + secondColRight) / 2;

    $infoWrap.css({
      left: `${midX - footerLeft}px`,
      top: "50%",
      transform: "translate(-50%, -50%)"
    });
  };

  useEffect(() => {
    if (loading || !rows.length || !cols.length) return;

    const $table = $(tableRef.current);
    if (!$table.length) return;

    if ($.fn.dataTable.isDataTable($table)) {
      $table.DataTable().destroy(true);
      $table.empty();
    }

    const safeData = rows.map((r) => ({
      username: r.username,
      rnr1: formatValue(r.rnr1),
      rnr1_sort: Number(r.rnr1?.value ?? 0),
      rnr2: formatValue(r.rnr2),
      rnr2_sort: Number(r.rnr2?.value ?? 0),
      rnr3: r.rnr3 ? formatValue(r.rnr3) : "",
      rnr3_sort: r.rnr3 ? Number(r.rnr3.value ?? 0) : 0
    }));

    $table.DataTable({
      data: safeData,
      columns: cols,

      responsive: false,

      paging: true,
      pageLength: 100,
      lengthChange: true,
      lengthMenu: [100, 250, 500, 1000],

      searching: true,
      info: true,

      ordering: true,
      order: [[0, "asc"]],
      autoWidth: false,
      orderClasses: false,
      pagingType: "simple_numbers",
      dom:
        '<"row mb-2 bet-id-wise-details-dt-toolbar justify-content-center align-items-center"<"col-auto"l><"col-auto"f>>' +
        "rt" +
        '<"row mt-2 bet-id-wise-details-dt-footer justify-content-end align-items-center"<"col-auto bet-id-wise-details-dt-info-wrap"i><"col-auto"p>>',

      initComplete: function () {
        alignFooterInfoBetweenFirstTwoColumns(this.api());
      },

      drawCallback: function () {
        alignFooterInfoBetweenFirstTwoColumns(this.api());
      },

      language: {
        paginate: {
          previous: "Previous",
          next: "Next"
        },
        lengthMenu: "Show _MENU_ entries",
        search: "Search:",
        searchPlaceholder: ""
      },

      rowCallback: function (row, data, index) {
        const isMobile = window.matchMedia("(max-width:640px)").matches;
        const bgColor =
          isMobile || index % 2 === 0 ? "#f9f9f9" : "#ffffff";
        $(row).css("background-color", bgColor);
        $("td", row).css("background-color", bgColor);
      }
    });

    const onResize = () => {
      if ($.fn.dataTable.isDataTable($table)) {
        alignFooterInfoBetweenFirstTwoColumns($table.DataTable());
      }
    };
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      if ($.fn.dataTable.isDataTable($table)) {
        $table.DataTable().destroy(true);
      }
    };
  }, [rows, cols, loading, gridKey]);

  return (
    <div className="bet-id-wise-details">
      <main className="main">
        <div className="container-fluid bet-id-wise-details-container">
          {loading && (
            <div
              style={{
                textAlign: "center",
                position: "absolute",
                left: 0,
                right: 0,
                zIndex: 999
              }}
            >
              <img src="/assets/images/loadinggif.gif" alt="" />
            </div>
          )}

          <div className="animated fadeIn" style={{ margin: "8px" }}>
            <div
              style={{
                fontWeight: "bold",
                margin: "5px",
                padding: "4px 15px",
                background: "#fff"
              }}
              className="site_family bet-id-wise-details-event-title"
            >
              {event?.evt_evt}
            </div>

            <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
              <button
                className="btn btn-primary site_family bet-id-wise-details-refresh-btn"
                onClick={() => fetchData(activeTab)}
              >
                Refresh
              </button>
            </div>

            <div className="card-body">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <a
                    href="#"
                    style={{
                      width: "63px",
                      padding: "5px",
                      textAlign: "center"
                    }}
                    className={`site_family nav-link ${
                      activeTab === "allusers" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab("allusers");
                    }}
                  >
                    ALL
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    style={{
                      width: "103px",
                      padding: "5px",
                      textAlign: "center"
                    }}
                    href="#"
                    className={`site_family nav-link ${
                      activeTab === "myusers" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab("myusers");
                    }}
                  >
                    My Users
                  </a>
                </li>
              </ul>
              <hr className="bet-id-wise-details-tabs-divider" />

              <div className="tab-content p-2">
                <div className="tab-pane fade show active">
                  <div className="bet-id-wise-details-table-wrap" key={gridKey}>
                    <table
                      ref={tableRef}
                      className="table table-striped table-bordered dataTable no-footer display mt-2"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {cols.map((c) => (
                            <th key={c.data} className="site_family">
                              {c.title}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style>{`
  html.${PAGE_BODY_CLASS},
  body.${PAGE_BODY_CLASS},
  body.${PAGE_BODY_CLASS} #root {
    background-color: #fff !important;
    background-image: none !important;
  }

  .bet-id-wise-details,
  .bet-id-wise-details .main,
  .bet-id-wise-details .container-fluid,
  .bet-id-wise-details .animated,
  .bet-id-wise-details .card-body,
  .bet-id-wise-details .tab-content,
  .bet-id-wise-details .tab-pane {
    background-color: #fff !important;
  }

  .bet-id-wise-details {
    min-height: calc(100vh - 255px);
    width: 100%;
    box-sizing: border-box;
  }

  .bet-id-wise-details .bet-id-wise-details-event-title {
    font-size: calc(1em + 4px);
  }

  .bet-id-wise-details .bet-id-wise-details-container {
    padding: 20px !important;
    box-sizing: border-box;
  }

  .bet-id-wise-details .tab-content,
  .bet-id-wise-details .tab-pane {
    border: none !important;
    overflow: visible !important;
  }

  .bet-id-wise-details .bet-id-wise-details-table-wrap,
  .bet-id-wise-details .dt-container {
    border: none !important;
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow: visible !important;
    padding-right: 1px;
  }

  .bet-id-wise-details .table.table-bordered {
    border: 1px solid #ddd !important;
    border-collapse: collapse !important;
    width: 100% !important;
    max-width: 100%;
    box-sizing: border-box;
  }

  .bet-id-wise-details .table.table-bordered th:last-child,
  .bet-id-wise-details .table.table-bordered td:last-child {
    border-right: 1px solid #ddd !important;
  }

  .bet-id-wise-details .dt-container .table.dataTable {
    width: 100% !important;
    max-width: 100%;
  }

  .bet-id-wise-details table.dataTable > thead > tr > th,
  .bet-id-wise-details table.dataTable > tbody > tr > td {
    display: table-cell !important;
  }

  @media screen and (max-width: 640px) {
    .bet-id-wise-details .bet-id-wise-details-container {
      padding: 8px !important;
    }

    .bet-id-wise-details .bet-id-wise-details-table-wrap,
    .bet-id-wise-details .dt-container {
      overflow: auto !important;
    }

    .bet-id-wise-details .table.dataTable {
      table-layout: fixed !important;
      width: 100% !important;
    }

    .bet-id-wise-details .table.table-bordered th,
    .bet-id-wise-details .table.table-bordered td {
      padding: 6px 4px !important;
      font-size: 13px !important;
      min-width: 0;
      word-break: break-word;
      overflow-wrap: anywhere;
    }

    .bet-id-wise-details thead th .dt-column-header {
      gap: 2px;
    }

    .bet-id-wise-details thead th .dt-column-order,
    .bet-id-wise-details thead th.dt-ordering-desc .dt-column-order,
    .bet-id-wise-details thead th.dt-ordering-asc .dt-column-order {
      flex: 0 0 14px;
      width: 14px;
      min-width: 14px;
      flex-basis: 14px;
      height: 14px;
      background-size: 14px 14px;
    }
  }

  .bet-id-wise-details .table.table-bordered th,
  .bet-id-wise-details .table.table-bordered td {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: #ddd !important;
    text-align: left !important;
    white-space: normal !important;
  }

  .bet-id-wise-details .table.dataTable th.dt-type-numeric,
  .bet-id-wise-details .table.dataTable td.dt-type-numeric {
    text-align: left !important;
  }

  .bet-id-wise-details thead th {
    font-weight: 700 !important;
    vertical-align: middle !important;
    background-image: none !important;
  }

  .bet-id-wise-details .table.table-bordered thead tr th {
    border-bottom: 3px solid #ddd !important;
  }

  .bet-id-wise-details thead th::before,
  .bet-id-wise-details thead th::after {
    display: none !important;
    content: none !important;
  }

  .bet-id-wise-details thead th .dt-column-header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100%;
    gap: 8px;
    text-align: left !important;
  }

  .bet-id-wise-details thead th .dt-column-title {
    flex: 1 1 auto;
    min-width: 0;
  }

  .bet-id-wise-details thead th .dt-column-order {
    flex: 0 0 29px;
    width: 29px;
    min-width: 29px;
    height: 18px;
    margin-left: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 29px 18px;
    cursor: pointer;
    opacity: 1;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='16' viewBox='0 0 18 16'%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M5 2v8'/%3E%3Cpath fill='%23888888' d='M5 13.5 2 10h6z'/%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M10 14V6'/%3E%3Cpath fill='%23888888' d='M10 2.5 7 6h6z'/%3E%3C/svg%3E");
  }

  .bet-id-wise-details thead th .dt-column-order::before,
  .bet-id-wise-details thead th .dt-column-order::after {
    display: none !important;
    content: none !important;
  }

  .bet-id-wise-details thead th.dt-orderable-none .dt-column-order {
    display: none !important;
    background-image: none !important;
  }

  .bet-id-wise-details thead th.dt-ordering-desc .dt-column-order {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M5 2v8'/%3E%3Cpath fill='%23888888' d='M5 13.5 2 10h6z'/%3E%3Crect x='9' y='2.5' width='8' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='6' width='6' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='9.5' width='4' height='2' fill='%23aaaaaa'/%3E%3C/svg%3E");
    width: 33px;
    flex: 0 0 33px;
    flex-basis: 33px;
    min-width: 33px;
    height: 18px;
    background-size: 33px 18px;
  }

  .bet-id-wise-details thead th.dt-ordering-asc .dt-column-order {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M5 14V6'/%3E%3Cpath fill='%23888888' d='M5 2.5 2 6h6z'/%3E%3Crect x='9' y='11.5' width='8' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='8' width='6' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='4.5' width='4' height='2' fill='%23aaaaaa'/%3E%3C/svg%3E");
    width: 33px;
    flex: 0 0 33px;
    flex-basis: 33px;
    min-width: 33px;
    height: 18px;
    background-size: 33px 18px;
  }

  .bet-id-wise-details .bet-id-wise-details-tabs-divider {
    margin: 0 0 8px;
    border: 0;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #ddd;
  }

  .bet-id-wise-details .bet-id-wise-details-refresh-btn {
    background-color: #337ab7 !important;
    background-image: none !important;
    border: 1px solid #2e6da4 !important;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-toolbar {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: center !important;
    align-items: center !important;
    gap: 24px;
    width: 100%;
    margin-right: 0 !important;
    padding-right: 0 !important;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-toolbar > .col-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .dt-length,
  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .dataTables_length,
  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .dt-search,
  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px;
    float: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: auto !important;
    justify-content: center !important;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-toolbar label {
    margin-bottom: 0 !important;
    white-space: nowrap;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-toolbar select.form-control,
  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .custom-select {
    width: auto !important;
    min-width: 4.5rem;
    display: inline-block;
    border: 1px solid #ced4da !important;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 1.75rem 0.25rem 0.5rem;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .dt-search input[type="search"],
  .bet-id-wise-details .bet-id-wise-details-dt-toolbar .dataTables_filter input[type="search"] {
    border: 1px solid #ced4da !important;
    width: 200px !important;
    max-width: none !important;
    margin: 0 !important;
    display: inline-block !important;
  }

  @media screen and (max-width: 640px) {
    .bet-id-wise-details .bet-id-wise-details-dt-toolbar {
      justify-content: center !important;
      gap: 12px;
    }
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer {
    position: relative !important;
    display: flex !important;
    flex-wrap: wrap;
    justify-content: flex-end !important;
    align-items: center !important;
    width: 100%;
    margin-top: 0.75rem !important;
    gap: 12px;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .bet-id-wise-details-dt-info-wrap {
    position: absolute;
    width: auto;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
    flex: 0 0 auto;
    z-index: 1;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer > .col-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .dt-info {
    float: none !important;
    text-align: center !important;
    padding: 0 !important;
    margin: 0 !important;
    color: #333;
    font-size: 16px;
    white-space: nowrap;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .dt-paging {
    float: none !important;
    text-align: right !important;
    margin: 0 !important;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .pagination {
    display: flex !important;
    flex-wrap: wrap;
    margin: 0 !important;
    padding: 0;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .dt-paging-button {
    margin-left: 0 !important;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .page-link {
    position: relative;
    display: block;
    padding: 0.375rem 0.75rem;
    color: #777;
    background-color: #fff;
    border: 1px solid #ddd !important;
    line-height: 1.25;
    margin-left: -1px;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .page-item:last-child .page-link {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .page-item.active .page-link {
    z-index: 1;
    color: #fff !important;
    background-color: #337ab7 !important;
    border-color: #337ab7 !important;
  }

  .bet-id-wise-details .bet-id-wise-details-dt-footer .page-item.disabled .page-link {
    color: #6c757d !important;
    background-color: #fff !important;
    border-color: #ddd !important;
    pointer-events: none;
  }

  @media screen and (max-width: 640px) {
    .bet-id-wise-details .bet-id-wise-details-dt-footer {
      flex-direction: column;
      align-items: center !important;
      text-align: center;
    }

    .bet-id-wise-details .bet-id-wise-details-dt-footer .bet-id-wise-details-dt-info-wrap {
      position: static !important;
      transform: none !important;
      left: auto !important;
      top: auto !important;
      width: 100%;
    }

    .bet-id-wise-details .bet-id-wise-details-dt-footer .dt-info {
      text-align: center !important;
    }

    .bet-id-wise-details .bet-id-wise-details-dt-footer .dt-paging {
      text-align: center !important;
    }
  }

  .bet-id-wise-details .nav-tabs {
    border-bottom: none !important;
  }

  .bet-id-wise-details .nav-tabs .site_family.nav-link {
    color: #337ab7 !important;
  }

  .bet-id-wise-details .nav-tabs .site_family.nav-link.active,
  .bet-id-wise-details .nav-tabs .nav-item.show .site_family.nav-link {
    border: none !important;
    border-color: transparent !important;
    color: #337ab7 !important;
  }

  .table { width: 100% !important; }
  .table.table-striped td, .table.table-striped th {
    padding: 6px 8px !important;
    font-size:17px;
    white-space: nowrap;
    vertical-align: middle;
  }
  table.table-sm td { padding: 4px 6px !important; }
  tr.shown + tr > td { background-color: #fafafa; }
  .seq-cell { display:flex; align-items:center; gap:6px; }
  .toggle-row {
    border: none;
    outline: none;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    line-height: 1;
  }
  .toggle-closed { background-color: #28a745; }
  .toggle-open { background-color: #dc3545; }
  .toggle-row:active { transform: scale(0.94); }
  .dt-info { float:none !important; text-align:center !important; }
  .dt-paging-button { margin-left:0 !important; padding: 0 !important; }
  .dt-paging { text-align:center !important; }
  .pagination { display:block !important; }

  .bet-id-wise-details .table tbody tr:nth-child(odd),
  .bet-id-wise-details .table tbody tr:nth-child(odd) > td {
    background-color: #f9f9f9 !important;
  }

  .bet-id-wise-details .table tbody tr:nth-child(even),
  .bet-id-wise-details .table tbody tr:nth-child(even) > td {
    background-color: #ffffff !important;
  }

  .bet-id-wise-details table.dataTable.order-column tbody tr > .sorting_1,
  .bet-id-wise-details table.dataTable.order-column tbody tr > .sorting_2,
  .bet-id-wise-details table.dataTable.order-column tbody tr > .sorting_3,
  .bet-id-wise-details table.dataTable.display tbody tr > .sorting_1,
  .bet-id-wise-details table.dataTable.display tbody tr > .sorting_2,
  .bet-id-wise-details table.dataTable.display tbody tr > .sorting_3 {
    background-color: inherit !important;
  }

  .table-striped tbody tr:nth-of-type(odd) { background-color: transparent; }
  .table tr:nth-child(even) { background-color: transparent; }

  table.dataTable.order-column tbody tr > .sorting_1,
  table.dataTable.order-column tbody tr > .sorting_2,
  table.dataTable.order-column tbody tr > .sorting_3,
  table.dataTable.display tbody tr > .sorting_1,
  table.dataTable.display tbody tr > .sorting_2,
  table.dataTable.display tbody tr > .sorting_3 {
    background-color: transparent;
  }

  .toggle-row { width:15px; height:15px; margin-left:2px; }

  .dt-search { float:right; padding-right:10px; }
  .dt-search .form-control{
    border: 1px solid #000;
    margin-bottom:5px;
  }

  .actionBtn {
    position: absolute;
    width: 100%;
    margin-top: 20px;
    z-index: 10;
  }

  /* MOBILE ONLY FIXES */
  @media screen and (max-width: 640px) {

    .actionBtn {
      width: 100%;
      margin-top: 20px;
      position: relative;
    }

    .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }

    .dataTable {
      margin-top:10px !important;
    }

    .bet-id-wise-details .bet-id-wise-details-table-wrap {
      margin-top:0px !important;
    }

    .dt-buttons {
      margin: 0 auto !important;
      float: none !important;
      width: auto !important;
      display: flex !important;
      justify-content: center;
    }
      
  }
        .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }
      @media screen and (max-width: 640px) {
  /* Make the top area stack nicely */
  .top.d-flex {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  /* Center the search container */
  .dt-search {
    display: flex !important;
    justify-content: center !important; /* center horizontally */
    width: 100% !important;
    margin: 8px 0 !important;
    padding: 0 12px;
    box-sizing: border-box;
  }

  /* Ensure the label + input stay inline and centered */
  .dt-search .dataTables_filter,
  .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    justify-content: center;
    width: auto !important;
    margin: 0;
  }

  /* Limit input width so it doesn't push other controls */
  .dt-search input[type="search"],
  .dataTables_filter input[type="search"] {
    width: 160px !important;
    max-width: 80% !important;
    display: inline-block !important;
    margin: 0 !important;
  }
    .dt-container {
      margin-top:0px !important;
    }
    }
    .dataTable {
    margin-top:15px;
    }
`}</style>
      </main>
    </div>
  );
};

export default BetIdWiseDetails;
